import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { PaymentDisplayHelpersModule } from '@features/payment-display-helpers/payment-display-helpers.module';
import { ApplicationPDFComponentComponent } from './application-pdf-component/application-pdf-component.component';
import { ApplicationPdfComponent } from './application-pdf/application-pdf.component';
import { AwardPdfPageComponent } from './award-pdf-page.component.ts/award-pdf-page.component';
import { GetComponentApplicableForPDFPipe } from './pipes/get-component-applicable-for-pdf.pipe';
import { MapComponentForPDFPipe } from './pipes/map-component-for-pdf.pipe';


@NgModule({
  imports: [
    GCCoreModule,
    PaymentDisplayHelpersModule
  ],
  declarations: [
    ApplicationPdfComponent,
    ApplicationPDFComponentComponent,
    AwardPdfPageComponent,
    GetComponentApplicableForPDFPipe,
    MapComponentForPDFPipe
  ]
})
export class ApplicationPdfModule { }
